import type { DefaultTheme } from 'styled-components';
import styled, { css } from 'styled-components';

import { hexToRgba } from '@/theme';
import type { ColorKeys } from '@/theme/types/colors';

const getBackgroundStyles = (
  theme: DefaultTheme,
  backgroundColor?: string | null,
) => {
  const background = backgroundColor ?? 'white';
  if (background === 'halfTransparent') {
    return css`
      background: linear-gradient(
        180deg,
        rgba(${hexToRgba(theme.colors.primary, '1')}) 20%,
        rgba(${hexToRgba(theme.colors.primary, '0')}) 100%
      );

      &::before {
        content: ' ';
        width: 100%;
        height: 100%;
        position: absolute;
        opacity: 0.8;
        background: rgba(${hexToRgba(theme.colors.primary, '1')});
      }
    `;
  } else {
    const key = (
      background === theme.components.header.defaultBackground
        ? 'primary'
        : background
    ) as ColorKeys;
    return css`
      background: ${theme.colors[key] ?? theme.colors.primary};
    `;
  }
};

export const Wrapper = styled.header<{
  $background?: string | null;
  $textColorOption: string;
}>`
  top: 0;
  left: 0;
  width: 100%;
  align-items: center;
  position: fixed;
  ${({ $background, theme }) => getBackgroundStyles(theme, $background)}

  ${({ theme: { zIndex } }) => css`
    z-index: ${zIndex.header};
    margin: 0 auto;
  `}
  ${({ $textColorOption, theme }) => css`
    @media (min-width: 768px) {
      ${$textColorOption === 'light'
        ? css`
            *,
            li > a,
            li p {
              color: ${theme.colors.white};
              &::after {
                background: ${theme.colors.white};
              }
            }
          `
        : css`
            *,
            li > a,
            li div {
              color: ${theme.colors.black};
            }
          `}
    }
  `}
`;
export const InnerWrapper = styled.div`
  width: 100%;
  padding: 0px 16px;
  margin: 0 auto;

  ${({
    theme: {
      components: {
        header: { innerWrapper },
      },
    },
  }) => css`
    max-width: ${innerWrapper.maxWidth};
  `}

  ${({ theme }) =>
    css`
      ${theme.media.md.up} {
        padding: 10px 157px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    `}
`;
